export const FETCHING_PATIENT_INIT = "meuspacientesplano.buscou_pacientes_init";
export const FETCHING_PATIENT_COMPLETE = "meuspacientesplano.buscou_pacientes_success";
export const FETCHING_PATIENT_ERROR = "meuspacientesplano.buscou_pacientes_Error";

export const RESET_PATIENT_FILTER = "meuspacientesplano.reset_filtro";